import { isNonBuilding } from '@mollusk/shared';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

/**
 * Small badge for a served row that is not a building permit (licence, parking,
 * inspection, enforcement or admin record — molluskio#5385). Such rows are kept
 * and counted like every other record; the badge identifies them. Renders
 * nothing for a building permit. A row is non-building when it carries the
 * `non_building_record` tag or the deprecated `non_building_excluded`
 * record_class (molluskio#6001) — see `isNonBuilding`.
 */
export function NonBuildingBadge({
  permit,
}: {
  permit: { tags?: readonly string[] | null; record_class?: string | null } | null | undefined;
}) {
  if (!permit || !isNonBuilding(permit)) return null;
  return (
    <Tooltip title="Not a building permit (e.g. licence, inspection, enforcement or admin record)">
      <Chip size="small" variant="outlined" label="Non-building record" sx={{ ml: 1 }} />
    </Tooltip>
  );
}
